import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, { makePostRequestAsync } from '../Helpers/httpRequestHelpers';
import { Permission } from './Messages/Permission';
import { RoleMessage } from './Messages/RoleMessage';
import { UserMessage } from './Messages/UserMessage';

// user management api call begin here
const baseUrl = `${protectedResources.userManagementWebApi.endpoint}/api/UserManagement`;
const scopes = protectedResources.userManagementWebApi.scopes;

export const GetActiveDefaultSystemRoles = async () => {
  const url = `${baseUrl}/roles/ActiveDefaultSystemRoles`;
  const result = await makeGetRequestAsync<RoleMessage[]>(scopes, url);
  return result.data;
};

export const GetCompanyUsersWithCompanyId = async (companyId: number) => {
  const url = `${baseUrl}/User/company/${companyId}`;
  const result = await makeGetRequestAsync<UserMessage[]>(scopes, url);
  return result.data;
};

export const GetCurrentUserPermissions = async () => {
  const url = `${baseUrl}/Permissions/User`;
  const result = await makeGetRequestAsync<Permission[]>(scopes, url);
  return result.data;
};

export const AssignDefaultCompanyUserRoles = async () => {
  const url = `${baseUrl}/User/AssignDefaultCompanyUserRoles`;
  await makePostRequestAsync(scopes, url);
};
